"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const util_1 = require("./util");
function GenomicSequence({ sequence, upstream, downstream, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        upstream ? (react_1.default.createElement("span", { style: { background: util_1.updownstreamColor } }, upstream)) : null,
        react_1.default.createElement("span", { style: { background: util_1.genomeColor } }, sequence),
        downstream ? (react_1.default.createElement("span", { style: { background: util_1.updownstreamColor } }, downstream)) : null));
}
exports.default = GenomicSequence;
